module.exports = __webpack_public_path__ + "img/oculus_hifi_3.5803dc4b.png";